import { AdminFormRow } from '@ui';
import { memo } from 'react';
import { ControlledPhoneInput } from '../components/inputs/ControlledPhoneInput';
import { ControlledTextInput } from '../components/inputs/ControlledTextInput';

type MainContactFormProps = {
  isReadOnly?: boolean;
  isNameRequired?: boolean;
  isPhoneRequired?: boolean;
};

export const MainContactForm = memo(
  ({ isReadOnly = false, isNameRequired = true, isPhoneRequired = true }: MainContactFormProps) => {
    return (
      <>
        <AdminFormRow title="First Name" isRequired={isNameRequired}>
          <ControlledTextInput
            name="firstName"
            aria-label="Contact First Name"
            isReadOnly={isReadOnly}
            isDisabled={isReadOnly}
          />
        </AdminFormRow>
        <AdminFormRow title="Last Name" isRequired={isNameRequired}>
          <ControlledTextInput
            name="lastName"
            aria-label="Contact Last Name"
            isReadOnly={isReadOnly}
            isDisabled={isReadOnly}
          />
        </AdminFormRow>
        <AdminFormRow title="Email">
          <ControlledTextInput
            name="email"
            aria-label="Contact Email"
            type="email"
            isReadOnly={isReadOnly}
            isDisabled={isReadOnly}
          />
        </AdminFormRow>
        <AdminFormRow title="Primary Phone" inputWrapperClass="max-w-[20rem]" isRequired={isPhoneRequired}>
          <ControlledPhoneInput name="primaryPhone" disabled={isReadOnly} />
        </AdminFormRow>
        <AdminFormRow title="Secondary Phone" inputWrapperClass="max-w-[20rem]">
          <ControlledPhoneInput name="secondaryPhone" disabled={isReadOnly} />
        </AdminFormRow>
      </>
    );
  },
);
